import React, {Component} from 'react';
import AccountInvoiceContainer from '../../../containers/account_invoice_container';
import {Button, Icon} from 'semantic-ui-react';
import ReactTable from "react-table";
import Loader from '../../universal/loader';
import {INVOICE} from "../../../constants/app_routes";
import {withRouter} from "react-router-dom";

class InvoiceEstimates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalEstimate: 0,
            filterApplied: false
        }
    }

    componentWillMount() {
        this.props.getInvoiceEstimates();
    }

    handleView = (id) => {
        this.props.history.push(`${INVOICE}/estimate/view/${id}`);
    };

    calculateSum = () => {
        if (this.selectTable) {
            const filteredData = this.selectTable.getResolvedState().sortedData;
            let totalEstimates = 0;
            if (filteredData) {
                for (let i = 0; i < filteredData.length; i++) {
                    totalEstimates += parseInt(filteredData[i]['total_amount_with_tax'],10);
                }
                this.setState({totalEstimate: totalEstimates, filterApplied: true});
            }
        }
    };

    calculateInitialSum = () => {
        const estimates = this.props.estimates;
        let totalEstimates = 0;

        if (estimates && estimates.length > 0) {

            for (let i = 0; i < estimates.length; i++) {
                totalEstimates += parseInt(estimates[i]['total_amount_with_tax'],10);
            }
            return totalEstimates;
        }
        return 0;
    };

    render() {

        const inspectionStatus = {
            "pending": 'Pending',
            "scheduled": 'Scheduled',
            "confirmed": 'Confirmed',
            "processing": 'Processing',
            "submitted": 'Submitted',
            "completed": 'Completed',
            "request_abort": 'Requested Abort',
            "aborted": 'Aborted',
            "request_cancel": 'Request Cancel',
            "cancelled": 'Cancelled'
        };
        const columns = [{
            Header: 'Date',
            accessor: 'date',
            className:'center-aligned',
            filterable: true
        }, {
            Header: 'Agent Ref.ID',
            accessor: 'agent_reference_id',
            className:'center-aligned',
            filterable: true
        }, {
            Header: 'Company Name',
            accessor: 'company',
            filterable: true
        }, {
            Header: 'Address Detail',
            accessor: 'address',
            className:'caddress-width',
            headerClassName:'caddress-width',
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            },
            filterable: true
        },{
            Header: 'Job Type',
            accessor: 'inspection_type',
            filterable: true,
            className: 'formatcase mini-width center-aligned',
            headerClassName: 'mini-width dropdown-overlay',
            // Filter: ({ filter, onChange }) => <Popup trigger={<Button size='mini'>Filter</Button>} content={<Dropdown placeholder='State' fluid multiple search selection options={options} onChange={(e) => {this.setState({dropdownValue:options.value})}}/>} on='click'/>,
            filterMethod: (filter, row) => {
                if (filter.value === "ci") {
                    return row[filter.id] === 'ci';
                }
                if (filter.value === "co") {
                    return row[filter.id] === 'co';
                }
                if (filter.value === "inv") {
                    return row[filter.id] === 'inv';
                }
                if (filter.value === "inv/ci") {
                    return row[filter.id] === 'inv/ci';
                }
                return true;
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : "all"}
                >
                    <option value="true">Show all</option>
                    <option value="ci">CI</option>
                    <option value="co">CO</option>
                    <option value="inv">INV</option>
                    <option value="inv/ci">INV/CI</option>
                </select>,

            Footer: (
                <div>
                    <span className="format-bold">Total:</span>
                </div>
            )
        }, {
            Header: 'Total Estimate',
            accessor: 'total_amount_with_tax',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
            Footer: (
                <div>
                    <span
                        className="format-bold">£ {this.state.filterApplied ? this.state.totalEstimate : this.calculateInitialSum()}</span>
                </div>
            )
        }, {
            Header: 'Job Status',
            className: 'center-aligned',
            accessor: 'inspection_status',
            Cell: ({value}) => (
                <div>
                    <Button size='mini' fluid><span>{inspectionStatus[value]}</span></Button>
                </div>
            ),
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            className:'center-aligned',
            accessor: 'id',
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                </div>
            )
        }];
        return (<div style={{minHeight: '550px'}} className="pad-bottom">
            {!this.props.isFetching && <ReactTable
                ref={(r) => {
                    this.selectTable = r;
                }}
                data={this.props.estimates}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                minRows={11}
                defaultPageSize={10000}
                showPagination={false}
                style={{
                    height: '550px'
                }}
                onFilteredChange={() => this.calculateSum()}
                noDataText="No Invoice Estimates Found"
            />}
            {this.props.isFetching && <Loader/>}
        </div>)
    }
}

export default AccountInvoiceContainer(withRouter(InvoiceEstimates));


// WEBPACK FOOTER //
// ./src/views/accounts/invoice/estimates.js